import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { MODERNIZE_CONFLUENCE_IPM_MODAL } from '../../constants/onboarding-state/onboarding-constants.ts';

import onboardingStateGetOnboardingStateQuery, {
	type onboardingStateGetOnboardingStateQuery$data,
	type onboardingStateGetOnboardingStateQuery$variables,
} from './__generated__/onboardingStateGetOnboardingStateQuery.graphql.ts';

export const preloadModernizeConfluenceOnboardingState = () => {
	return query<
		onboardingStateGetOnboardingStateQuery$data,
		onboardingStateGetOnboardingStateQuery$variables
	>({
		query: onboardingStateGetOnboardingStateQuery,
		variables: {
			key: [...Object.values(MODERNIZE_CONFLUENCE_IPM_MODAL)],
		},
	});
};
